import { inject, LOCALE_ID } from '@angular/core';
import { LoggerService } from '@core/services/logger.service.js';
import type { Locale } from '@mmscan/shared-types';
import { CookieService } from 'ngx-cookie-service';

export function localeIdFactory(cookieService: CookieService): string {
  const LOCALE_COOKIE_NAME = 'locale';
  const DEFAULT_LOCALE = 'en-CA';

  const logger = inject(LoggerService);

  try {
    const cookieLocale = cookieService.get(LOCALE_COOKIE_NAME) as Locale;

    if (cookieLocale) {
      switch (cookieLocale) {
        case 'EN_CA':
          return 'en-CA';
        case 'FR_CA':
          return 'fr-CA';
        default:
          return DEFAULT_LOCALE;
      }
    }

    const browserLang = navigator.language.toLowerCase();
    if (browserLang.startsWith('fr')) {
      return 'fr-CA';
    }

    return DEFAULT_LOCALE;
  } catch (error) {
    logger.warn('Failed to read locale from cookie, using default:', error);
    return DEFAULT_LOCALE;
  }
}

export const LOCALE_PROVIDER = {
  provide: LOCALE_ID,
  useFactory: localeIdFactory,
  deps: [CookieService],
};
